import * as y from 'yup'

export const getBooleanInputSchema = (required = false) => {
  let rule = y.boolean()
  if (required) rule = rule.required()
  return rule
}
